import React from 'react';
import '../styles/Agendar.css';
import { useNavigate } from 'react-router-dom';
import '../styles/Testimonios.css';

const ReservaPage = () => {
  const navigate = useNavigate();

  return (
    <div className="reserva-container">
      <h1>Reserva tu hora</h1>

      <div className="botones-reserva">
      <div className="opcion-reserva">
          <button className="boton-reserva" onClick={() => navigate('/reserva/disponibilidad')}>
            Por Especialidad
            
          </button>
          <p className="mensaje-reserva">Escoge esta opción si necesitas agendar por disponibilidad</p>

        </div>
       
        <div className="opcion-reserva">
          <button className="boton-reserva" onClick={() => navigate('/reserva/ecografia')}>
            Por Ecografía
          </button>
          <p className="mensaje-reserva">Escoge esta opción si necesitas agendar Ecografias</p>

        </div>
        <div className="opcion-reserva">
          <button className="boton-reserva" onClick={() => navigate('/reserva/profesional')}>
            Por Profesional
          </button>
          <p className="mensaje-reserva">Escoge esta opción si necesitas agendar con tu profesional.</p>
        </div>
      </div>
    </div>
  );
};

export default ReservaPage;